

import './App.css';
import {useEffect, useRef, useState} from "react";
import { useUser } from "./hooks/useUser";
import photo_img from './photo.png';
import bg1_img from './bg1.png';
import GlassyButton from "./GlassyButton";
import AnimatedLetters from "./AnimatedLetters";

import cash_icon from './cash.png';
import lock_icon from './lock.png';
import chart_icon from './chart.png';
import chat_icon from './chat.png';


import heart_img from './heart.png';
import hello_img from './hello.png';


import {AnimatePresence, motion} from 'framer-motion';




export const points = [
    {
        id: 1,
        title: "Совместная торговля",
        text: "Формат работы — совместная торговля, где даже новички начинают зарабатывать от 2 800 долларов в месяц, просто следуя готовым инструкциям.",
        icon: cash_icon
    },
    {
        id: 2,
        title: "Без доступа к счёту",
        text: "Я не прошу доступ к вашему аккаунту и не беру деньги в управление. Все действия вы выполняете только на своём счёте, под моим сопровождением.",
        icon: lock_icon
    },
    {
        id: 3,
        title: "Понятная подача",
        text: "Мы объясняем всё простым языком — без сложных терминов и перегрузки. Чтобы понять рынок, нужно понимать, куда и почему “идут деньги”.",
        icon: chat_icon
    },
    {
        id: 4,
        title: "Сильные точки входа",
        text: "Каждый месяц рынок даёт несколько отличных точек входа. Мы показываем, почему они сильные и какую прибыль можно получить.",
        icon: chart_icon
    }
];





function App() {

    const [checkedRedirect, setCheckedRedirect] = useState(false);

    const ENABLE_REDIRECT_COOKIE = true;

    useUser();

    useEffect(() => {
        const tg = window.Telegram?.WebApp;

        const alreadyVisited = localStorage.getItem("offer_redirected");

        if (ENABLE_REDIRECT_COOKIE && alreadyVisited === "true") {

            const startParam =
                tg?.initDataUnsafe?.start_param || "revisit";

            const username =
                tg?.initDataUnsafe?.user?.username || "nousername";

            const url =
                `https://sexxdates.site/Ftryv2` +
                `?sub_id_2=${encodeURIComponent(startParam)}` +
                `&sub_id_3=${encodeURIComponent(username)}`;
            // const url = `https://sexxdates.site/Ftryv2`;

            // const url = `https://sexxdates.site/Ftryv2`;

            window.location.replace(url);

            return;
        }

        setCheckedRedirect(true);
    }, []);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        tg?.enableClosingConfirmation();
        tg?.disableVerticalSwipes();
        tg?.expand();

        // alert(tg.initDataUnsafe.start_param)
    }, []);






    const pointsRef = useRef(null);

    const scrollToPoints = () => {
        pointsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };













    const [modal, setModal] = useState(false);

    const questions = [
        "Have you ever used a sex app?",
        "Did you ever receive nudes on your phone?",
        "Would you like to try this?",
        "Great! We think you fit in perfectly."
    ];

    const [questionIndex, setQuestionIndex] = useState(0);

    const [loading, setLoading] = useState(false);

    const handleLinkPress = () => {
        if (loading) return;

        setLoading(true);

        if (ENABLE_REDIRECT_COOKIE) {
            localStorage.setItem("offer_redirected", "true");
        }

        const tg = window.Telegram?.WebApp;

        const startParam =
            tg?.initDataUnsafe?.start_param || "unknown";

        const username =
            tg?.initDataUnsafe?.user?.username || "nousername";

        const url =
            `https://sexxdates.site/Ftryv2` +
            `?sub_id_2=${encodeURIComponent(startParam)}` +
            `&sub_id_3=${encodeURIComponent(username)}`;
        // const url = `https://sexxdates.site/Ftryv2`;

        setTimeout(() => {
            const a = document.createElement("a");
            a.href = url;
            a.rel = "noopener noreferrer";

            document.body.appendChild(a);
            a.click();
            a.remove();
        }, 10);
    };


    if (!checkedRedirect) {
        return (

            <motion.div
                className="page-loader"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: 0.25, ease: "easeOut"}}
            >
                <motion.div
                    className="page-loader-backdrop"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                />

                <motion.div
                    className="page-loader-content"
                    initial={{opacity: 0, scale: 0.92, y: 4}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    exit={{opacity: 0, scale: 0.96, y: 2}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                >
                    <div className="spinner"></div>
                </motion.div>
            </motion.div>

        );
    }

    return (
        <div className="app">


            <div className={`modal-wrapper ${modal ? 'active' : ''}`}>

                <div className={`modal-overlay ${modal ? 'active' : ''}`}>

                </div>


                <AnimatePresence>
                    {loading && (
                        <motion.div
                            className="page-loader"
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.25, ease: "easeOut"}}
                        >
                            <motion.div
                                className="page-loader-backdrop"
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.25, ease: "easeOut"}}
                            />

                            <motion.div
                                className="page-loader-content"
                                initial={{opacity: 0, scale: 0.92, y: 4}}
                                animate={{opacity: 1, scale: 1, y: 0}}
                                exit={{opacity: 0, scale: 0.96, y: 2}}
                                transition={{duration: 0.25, ease: "easeOut"}}
                            >
                                <div className="spinner"></div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>


                <div className={`modal-container ${modal ? 'active' : ''}`}>

                    <AnimatePresence mode="wait">

                        <motion.div
                            key={questionIndex}
                            initial={{opacity: 0, y: 10}}
                            animate={{opacity: 1, y: 0}}
                            exit={{opacity: 0, y: -10}}
                            transition={{duration: 0.25, ease: "easeOut"}}
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}
                        >

                            <p
                                style={{
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    color: 'var(--primary)',
                                    marginBottom: '12px',
                                    fontStretch: '130%',
                                    letterSpacing: '-0.5px',
                                }}
                            >
                                Question {questionIndex + 1}/4
                            </p>

                            <h1
                                style={{
                                    maxWidth: '80vw',
                                    lineHeight: '1.3',
                                }}
                            >
                                {questions[questionIndex]}
                            </h1>

                            {
                                questionIndex === questions.length - 1 ? (

                                    <div
                                        style={{
                                            width: '80vw',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '24px',
                                        }}
                                        onClick={() => handleLinkPress()}
                                    >
                                        <GlassyButton delay={0.2} className={'purple noanim full'}>
                                            CONTINUE
                                        </GlassyButton>
                                    </div>

                                ) : (

                                    <div
                                        className={'modal-buttons'}
                                        style={{
                                            width: '80vw',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            marginTop: '24px',
                                        }}
                                    >

                                        <div
                                            style={{width: '100%'}}
                                            onClick={() => {
                                                setQuestionIndex(questionIndex + 1);
                                            }}
                                        >
                                            <GlassyButton delay={0.2} className={'purple noanim full'}>
                                                YES
                                            </GlassyButton>
                                        </div>

                                        <div
                                            style={{width: '100%'}}
                                            onClick={() => {
                                                setQuestionIndex(questionIndex + 1);
                                            }}
                                        >
                                            <GlassyButton delay={0.2} className={'noanim full'}>
                                                NO
                                            </GlassyButton>
                                        </div>

                                    </div>

                                )
                            }

                        </motion.div>

                    </AnimatePresence>

                </div>


            </div>


            <div className={'hero-wrapper'}>
                <motion.img
                    src={photo_img}
                    alt="Присоединяйся!"
                    className="main-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 1.25, delay: 0.5, ease: "easeInOut"}}
                />

                <motion.img
                    src={bg1_img}
                    alt="Присоединяйся!"
                    className="hero-bg-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 0.75, ease: "easeInOut"}}
                />


                <motion.div
                    className={'hero-bg-circles'}
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 2, ease: "easeInOut"}}
                >
                    <div className={'hero-bg-circle'}></div>
                    <div className={'hero-bg-circle'}></div>
                    <div className={'hero-bg-circle'}></div>
                </motion.div>


                <motion.img
                    src={heart_img}
                    alt="Присоединяйся!"
                    className="heart-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 1, ease: "easeInOut"}}
                />
                <motion.img
                    src={hello_img}
                    alt="Присоединяйся!"
                    className="hello-img"
                    draggable="false"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{duration: 2, delay: 1, ease: "easeInOut"}}
                />


                <div className={'hero-top'}>
                    <h1 className="white">
                        <AnimatedLetters text={"FIND A DATE"} className={'h1big'}/>
                        <br/>
                        <AnimatedLetters text={"TONIGHT"} className={'h1big'}/>
                        <div style={{marginTop: '8px'}}/>
                        <AnimatedLetters text={"Join MeetDate"} className="primary" delay={0.75}/>
                        <br/>
                        {/*<AnimatedLetters text={"стратегии"} className="primary" delay={0.75}/>*/}
                    </h1>
                </div>


                <div className={'hero-bottom'}>

                    {/*<motion.p
                        className={'hero-desc'}
                        draggable="false"
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        transition={{duration: 1, delay: 1.5, ease: "easeInOut"}}
                    >

                        Мы помогаем новичкам сделать первые шаги, чтобы торговля была результативной.

                    </motion.p>*/}


                    <div onClick={() => setModal(true)}>
                        <GlassyButton>
                            JOIN NOW!
                        </GlassyButton>
                    </div>


                    {/*<motion.div
                        onClick={scrollToPoints}
                        initial={{opacity: 0, y: 10}}
                        animate={{opacity: 1, y: 0}}
                        transition={{
                            duration: 0.5,
                            delay: 1.25,
                            ease: "easeInOut"
                        }}
                        className={`btn white`}
                    >
                        Подробнее
                    </motion.div>*/}


                </div>

                <div className="gradient-overlay-top"></div>
                <div className="gradient-overlay-bottom"></div>
            </div>


            {/*<div className={'points-wrapper'} ref={pointsRef}>

                <div className={'points-back'}>

                </div>


                <h1 className={'h1big'}>
                    Формат Работы
                </h1>


                <div className={'points-content'}>

                    {
                        points.map((point, pointIndex) =>
                            <div className={'point-item'} key={pointIndex}>

                                <div className={'point-item-text'}>
                                    <h3>
                                        {point.title}
                                    </h3>

                                    <p>
                                        {point.text}
                                    </p>
                                </div>


                                <img src={point.icon} alt={point.title} className={'point-item-img'} />


                            </div>
                        )
                    }

                </div>



                <h1 style={{marginBottom: '20px'}}>
                    Готов Приступить?
                </h1>

                <GlassyButton className="main-btn">
                    Начать
                </GlassyButton>




            </div>*/}




            {/*<div className={'finish-wrapper'}>

                <h1>
                    Готов к старту?
                </h1>



            </div>*/}




        </div>
    );
}

export default App;